import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M14.667 1.333H1.333A.667.667 0 0 0 .667 2v2.667A2 2 0 0 0 2 6.547V14a.666.666 0 0 0 .667.667h10.666A.666.666 0 0 0 14 14V6.547a2 2 0 0 0 1.333-1.88V2a.666.666 0 0 0-.666-.667M10 2.667h1.333v2a.666.666 0 1 1-1.333 0zm-2.667 0h1.334v2a.667.667 0 1 1-1.334 0zm-2.666 0H6v2a.667.667 0 0 1-1.333 0zm-2 2.666A.667.667 0 0 1 2 4.667v-2h1.333v2a.667.667 0 0 1-.666.666m6.666 8H6.667v-2.666a1.333 1.333 0 0 1 2.666 0zm3.334 0h-2v-2.666a2.667 2.667 0 1 0-5.334 0v2.666h-2V6.547c.245-.091.471-.227.667-.4a2 2 0 0 0 2.667 0 2 2 0 0 0 2.666 0 2 2 0 0 0 2.667 0c.195.173.422.309.667.4zM14 4.667a.667.667 0 0 1-1.333 0v-2H14z"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })